import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { router } from "@inertiajs/react";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

const themes = [
  {
    id: "light" as const,
    label: "Claro",
    description: "Tema com fundo claro",
    icon: Sun,
  },
  {
    id: "dark" as const,
    label: "Escuro",
    description: "Tema com fundo escuro",
    icon: Moon,
  },
  {
    id: "system" as const,
    label: "Sistema",
    description: "Segue a preferência do sistema",
    icon: Monitor,
  },
];

export function AppearanceSection() {
  const { setTheme, theme: currentTheme } = useTheme();

  function handleThemeChange(themeId: string) {
    setTheme(themeId);
    router.put(
      "/app/settings",
      { section: "appearance", theme: themeId },
      { preserveState: true, preserveScroll: true },
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Aparência</CardTitle>
        <CardDescription>
          Personalize a aparência da interface.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 sm:grid-cols-3">
          {themes.map((theme) => {
            const Icon = theme.icon;
            const isActive = currentTheme === theme.id;
            return (
              <button
                key={theme.id}
                onClick={() => handleThemeChange(theme.id)}
                className={cn(
                  "flex flex-col items-center gap-3 rounded-xl border-2 p-6 transition-all",
                  isActive
                    ? "border-primary bg-primary/5 dark:bg-primary/10"
                    : "border-transparent bg-muted/50 hover:bg-muted",
                )}
              >
                <div
                  className={cn(
                    "flex size-12 items-center justify-center rounded-full",
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "bg-muted-foreground/10 text-muted-foreground",
                  )}
                >
                  <Icon className="size-5" />
                </div>
                <div className="text-center">
                  <p className="text-sm font-medium">{theme.label}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {theme.description}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
